import { render, staticRenderFns } from "./AddVideoModal.vue?vue&type=template&id=24e7cf9b&scoped=true&"
import script from "./AddVideoModal.vue?vue&type=script&lang=js&"
export * from "./AddVideoModal.vue?vue&type=script&lang=js&"
import style0 from "./AddVideoModal.vue?vue&type=style&index=0&id=24e7cf9b&prod&lang=less&scoped=true&"
import style1 from "./AddVideoModal.vue?vue&type=style&index=1&id=24e7cf9b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e7cf9b",
  null
  
)

export default component.exports